import common from './common.json'
import commonEn from './commonEn.json'
import event from './event.json'
import careerNewbie from './careerNewbie.json'
import onboarding from './onboarding.json'
import giveARecommendation from './give-a-recommendation.json'

const translate = { common, commonEn, event, giveARecommendation, onboarding, careerNewbie }
export default translate
